<template>
  <span justify="center">
    <v-card class="">
      <v-toolbar  dark color="#1D2E4B">
        <v-toolbar-title class="text-uppercase">Detalles de la Apelación</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="$emit('closeModal')">
            <v-icon
              right
              dark
              class="mr-1"
            >
              mdi-arrow-left
            </v-icon>
            Regresar
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card elevation="2" class="my-4 mx-4">
        <v-card-title style="color: #B08836">
          <v-spacer></v-spacer>
          <v-menu offset-y v-if="apelacion && cuenta">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="apelacion.status >= 40 &&
                      apelacion.status != 45 &&
                      role == 'magistrado' &&
                      (cuenta.ponencia_id == currentUser.ponencia_id)"
                color="#1D2E4B"
                dark
                v-bind="attrs"
                v-on="on"
              >
                Acciones del Toca
              </v-btn>
            </template>
            <v-list>
              <!-- <v-list-item
                v-if="$route.name != 'CuentaSinMateria'"
                link
                @click="$router.replace({ name:'CuentaSinMateria' })"
              >
                <v-list-item-title>Dejar Sin Materia</v-list-item-title>
              </v-list-item> -->
              <v-list-item
              @click="sinMateria()"
              >
                <v-list-item-title>Dejar Sin Materia</v-list-item-title>
              </v-list-item>
              <!-- <v-list-item
                v-if="$route.name != 'CuentaCancelar'"
                link
                @click="$router.replace({ name:'CuentaCancelar' })"
              >
                <v-list-item-title>Cancelar Toca</v-list-item-title>
              </v-list-item> -->
              <v-list-item
              @click="cancelaToca()"
              >
                <v-list-item-title>Cancelar</v-list-item-title>
              </v-list-item>
              <!-- <v-list-item
                v-if="$route.name != 'CuentaExcusar' && apelacion.status >= 43"
                link
                @click="$router.replace({ name:'CuentaExcusar' })"
              >
                <v-list-item-title>Excusar</v-list-item-title>
              </v-list-item> -->
            </v-list>
          </v-menu>
        </v-card-title>
        <v-card-text style="color: grey">
          <v-row class="mb-n5">
            <v-col cols="12">

              <!-- toca -->
              <div>
                <v-chip
                  class="ml-n7 font-weight-black"
                  color="#607D8B"
                  text-color="white"
                  label
                >
                  TOCA
                </v-chip>
                <div class="mt-6">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th class="text-center font-weight-bold pl-0 body-2">
                          NUM. TOCA
                        </th>
                        <th class="text-center font-weight-bold pl-0 body-2">
                          EXPEDIENTE
                        </th>
                        <th class="text-center font-weight-bold pl-0 body-2">
                          NÚM.OFICIO
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td class="text-center  body-1 pl-0">
                          {{ apelacion.toca.numero }}/{{ apelacion.toca.anio }}
                        </td>
                        <td class=" text-center body-1 pl-0">
                          {{ apelacion.toca.expediente }}
                        </td>
                        <td class=" text-center body-1 pl-0">
                          {{ apelacion.oficio }}
                        </td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
              </div>

              <!-- origen -->
              <div class="mt-6">
                <div>
                  <v-chip
                   class="ml-n7 font-weight-black"
                    color="#607D8B"
                    text-color="white"
                    label
                  >
                    ORIGEN
                  </v-chip>
                </div>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                    <tr>
                      <th class="text-center font-weight-bold pl-0 body-2">
                        MUNICIPIO
                      </th>
                      <th class="text-center font-weight-bold pl-0 body-2">
                        JUZGADO
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td
                        class="text-center  body-1 pl-0"
                      >
                        {{ apelacion.juzgado.municipio_data.nombre }}
                      </td>
                      <td
                        class=" text-center  body-1 pl-0"
                      >
                        {{ apelacion.juzgado.nombre }}<br>
                        DISTRITO {{ apelacion.juzgado.distrito_data.nombre }}
                      </td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>

              <!-- partes Actor /demandado -->
              <div class="mt-6">
                <div>
                  <v-chip
                    class="ml-n7 font-weight-black"
                    color="#607D8B"
                    text-color="white"
                    label
                  >
                    PARTES
                  </v-chip>
                </div>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                    <tr>
                      <th class="text-center font-weight-bold pl-0 body-2">
                        APELANTE
                      </th>
                      <th class="text-center font-weight-bold pl-0 body-2">
                        INCULPADO
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td class="text-center  body-1 pl-0">
                        {{ apelacion.apelante }}
                      </td>
                      <td class=" text-center  body-1 pl-0">
                        {{ apelacion.inculpado }}
                      </td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>

              <!-- detalles -->
              <div class="mt-6">
                <div>
                  <v-chip
                    class="ml-n7 font-weight-black"
                    color="#607D8B"
                    text-color="white"
                    label
                  >
                    DETALLES
                  </v-chip>
                </div>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                    <tr>
                      <th class="text-center font-weight-bold pl-0 body-2">
                        TIPO DE OFICIO
                      </th>
                      <th class="text-center font-weight-bold pl-0 body-2">
                        TIPO DE RECURSO
                      </th>
                      <th class="text-center font-weight-bold pl-0 body-2">
                        DELITO(S)
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td class=" text-center  body-1 pl-0">
                        {{ apelacion.tipo_apelacion.nombre }}
                      </td>
                      <td class=" text-center  body-1 pl-0">
                        {{ apelacion.tipo_apelacion.tipo_recurso }}
                      </td>
                      <td class="  body-1 pl-0">
                        <ul v-for="(delito, i) in apelacion.apelacion_delitos" :key="i">
                          <li>{{ delito.nombre }}</li>
                        </ul>
                      </td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>

              <!-- fechas -->
              <div class="mt-6">
                <div>
                  <v-chip
                    class="ml-n7 font-weight-black"
                    color="#607D8B"
                    text-color="white"
                    label
                  >
                    FECHAS
                  </v-chip>
                </div>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                    <tr>
                      <th class="text-center font-weight-bold pl-0 body-2">
                        AUTO APELANTE
                      </th>
                      <th class="text-center font-weight-bold pl-0 body-2">
                        RECEPCION
                      </th>
                      <th class="text-center font-weight-bold pl-0 body-2">
                        CITACIÓN
                      </th>
                      <th class="text-center font-weight-bold pl-0 body-2">
                        TURNO
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="hover:transparent">
                      <td class="text-center  body-1 pl-0">
                        {{ apelacion.fecha_apelacion | formatDate }}
                      </td>
                      <td class="text-center  body-1 pl-0">
                        {{ apelacion.fecha_recepcion.slice(0,10) | formatDate }}
                      </td>
                      <td class=" text-center  body-1 pl-0">
                        <span v-if="apelacion.fecha_citacion">
                        {{ apelacion.fecha_citacion | formatDate }}
                        </span>
                        <span v-else>
                          <v-icon
                            class="mr-2"
                            color="grey"
                          >
                            mdi-minus
                          </v-icon>
                        </span>
                      </td>
                      <td class=" text-center  body-1 pl-0">
                        <span v-if="apelacion.fecha_turno">
                        {{ apelacion.fecha_turno | formatDate }}
                        </span>
                        <span v-else>
                          <v-icon
                            class="mr-2"
                            color="grey"
                          >
                            mdi-minus
                          </v-icon>
                        </span>
                      </td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>

              <!-- cuenta -->
              <div class="mt-6" v-if="role != 'secacu' && (cuenta && cuenta.status >= 40)">
                <div>
                  <v-chip
                    class="ml-n7 font-weight-black"
                    color="#607D8B"
                    text-color="white"
                    label
                  >
                    CUENTA
                  </v-chip>
                </div>
                <v-simple-table class="mb-4">
                  <template v-slot:default>
                    <thead>
                    <tr>
                      <th class="text-center font-weight-bold pl-0 body-2">
                        RELATOR
                      </th>
                      <th class="text-center font-weight-bold pl-0 body-2">
                        MAGISTRADO
                      </th>
                      <th class="text-center font-weight-bold pl-0 body-2">
                        FECHA CUENTA
                      </th>
                      <th class="text-center font-weight-bold pl-0 body-2">
                        FECHA SENTENCIA
                      </th>
                      <th class="text-center font-weight-bold pl-0 body-2">
                        FECHA BAJA
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="hover:transparent">
                      <td class="text-center  body-1 pl-0">
                        {{ cuenta.nombre_relator }}
                      </td>
                      <td class="text-center  body-1 pl-0">
                        {{ cuenta.nombre_magistrado }}
                      </td>
                      <td class=" text-center  body-1 pl-0">
                        <span v-if="cuenta.fecha_cuenta">
                        {{ cuenta.fecha_cuenta | formatDate }}
                        </span>
                        <span v-else>
                          <v-icon
                            class="mr-2"
                            color="grey"
                          >
                            mdi-minus
                          </v-icon>
                        </span>
                      </td>
                      <td class=" text-center  body-1 pl-0">
                        <span v-if="cuenta.fecha_sentencia">
                        {{ cuenta.fecha_sentencia | formatDate }}
                        </span>
                        <span v-else>
                          <v-icon
                            class="mr-2"
                            color="grey"
                          >
                            mdi-minus
                          </v-icon>
                        </span>
                      </td>
                      <td class=" text-center  body-1 pl-0">
                        <span v-if="cuenta.fecha_baja">
                          {{ cuenta.fecha_baja | formatDate }}
                        </span>
                        <span v-else>
                          <v-icon
                            class="mr-2"
                            color="grey"
                          >
                            mdi-minus
                          </v-icon>
                        </span>
                      </td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <v-divider></v-divider>
              </div>

              <!-- Apelación electrónica -->
              <div class="mt-6" v-if="apelacion.hash">
                <v-expansion-panels  class="mx-n4" flat>
                  <v-expansion-panel>
                  <v-expansion-panel-header class="text-uppercase">
                    <template v-slot:default="{ open }">
                      <v-row no-gutters>
                        <v-col cols="4">
                          <v-chip
                            class=" font-weight-black ma-n9"
                            color="#607D8B"
                            text-color="white"
                            label
                             >
                            APELACIÓN ELECTRÓNICA
                          </v-chip>
                        </v-col>
                        <v-col
                          cols="8"
                          class="text--secondary"
                        >
                          <v-fade-transition leave-absolute>
                            <span
                              v-if="open"
                              key="0"
                              style="color:#D81B60"
                            >
                             <b>Detalles de la Apelación Electrónica</b>
                            </span>
                            <span
                              v-else
                              key="1"
                              style="color:#D81B60"
                            >
                            <b>Mostrar Detalles</b>
                            </span>
                          </v-fade-transition>
                        </v-col>
                      </v-row>
                    </template>
                  </v-expansion-panel-header>
                <v-expansion-panel-content >
                  <ApelacionElectronica
                    :sala_id="currentUser.sala_id"
                    :hash="apelacion.hash"
                  ></ApelacionElectronica>
                </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-divider></v-divider>
              </div>

              <!-- observaciones relator -->
              <!-- <div class="mt-6"
                v-if="role != 'secacu' &&
                      (cuenta && cuenta.status >= 43) &&
                      cuenta.ponencia_id == currentUser.ponencia.id"
              >
                <div>
                  <v-chip
                    class="ml-n7 font-weight-black"
                    color="#607D8B"
                    text-color="white"
                    label
                  >
                    OBSERVACIONES DE PRECUENTA RELATOR
                  </v-chip>
                </div>
                <div class="mt-4 mb-4" style="color: black;" v-html="cuenta.observaciones"></div>
                <v-divider></v-divider>
              </div> -->

              <!-- observaciones magistrado-->
              <!-- <div class="mt-6"
                v-if="role != 'secacu' &&
                      (cuenta && cuenta.status >= 43)&&
                      cuenta.ponencia_id == currentUser.ponencia.id"
              >
                <div>
                  <v-chip
                    class="ml-n7 font-weight-black"
                    color="#607D8B"
                    text-color="white"
                    label
                  >
                    OBSERVACIONES DE PRECUENTA MAGISTRADO
                  </v-chip>
                </div>
                <div class="mt-4 mb-4" style="color: black;" v-html="cuenta.observaciones_mag"></div>
                <v-divider></v-divider>
              </div> -->

              <div v-if="(cuenta && cuenta.status >= 44)">
                <!-- sentido -->
                <!-- <div class="mt-6" v-if="role != 'secacu' && (cuenta && cuenta.status >= 43)">
                  <div>
                    <v-chip
                      class="ml-n7 font-weight-black"
                      color="red"
                      text-color="white"
                      label
                    >
                      SENTIDO
                    </v-chip>
                  </div>
                  <div class="mt-4 mb-4" style="color: green;">
                    <div v-if="cuenta.sentido_ponencia_id == cuenta.sentido_colegiada_id">
                      Aprobado El Sentido de Ponencia<br>
                      {{ cuenta.sentido_ponencia }}
                    </div>
                    <div v-else>
                      Se Modificó el Sentido de Ponencia<br>
                      <b>Ponencia:</b> {{ cuenta.sentido_ponencia }}<br>
                      <b>Sentido Final:</b> {{ cuenta.sentido_colegiada }}
                    </div>
                  </div>
                  <v-divider></v-divider>
                </div> -->

                <!-- observaciones magistrado colegiada-->
                <div class="mt-6"
                  v-if="role == 'magistrado' &&
                        cuenta &&
                        cuenta.status >= 43 &&
                        cuenta.colegiada">
                  <div>
                    <v-chip
                      class="ml-n7 font-weight-black"
                      color="#607D8B"
                      text-color="white"
                      label
                    >
                      OBSERVACIONES DE CUENTA COLEGIADA
                    </v-chip>
                  </div>
                  <div v-if="cuenta.colegiada.observacion_colegiada" class="mt-4 mb-4" style="color: black;" v-html="cuenta.colegiada.observacion_colegiada.observaciones"></div>
                  <div v-if="!cuenta.colegiada.observacion_colegiada" class="mt-4 mb-4" style="color: black;"></div>
                  <v-divider></v-divider>
                </div>

                <!-- votos -->
                <div class="mt-6"
                  v-if="role == 'magistrado' &&
                        cuenta &&
                        cuenta.status >= 43 &&
                        cuenta.colegiada">
                  <v-chip
                    class="ml-n7 font-weight-black hidden-md-and-up"
                    color="#607D8B"
                    text-color="white"
                    label
                  >
                    VOTOS
                  </v-chip>
                  <v-toolbar dense flat class="mb-2">
                    <v-chip
                      class="ml-n7 font-weight-black hidden-sm-and-down"
                      color="#607D8B"
                      text-color="white"
                      label
                    >
                      VOTOS
                    </v-chip>
                    <v-checkbox
                      v-if="!cuenta.colegiada.voto_particular &&
                            cuenta.status>=43 &&
                            cuenta.status != 45 &&
                            role =='magistrado'"
                      v-model="voto_particular"
                      class="mt-5 ml-4"
                      label="Voto Particular"
                    ></v-checkbox>
                    <v-checkbox
                      v-if="!cuenta.colegiada.voto_concurrente &&
                            cuenta.status>=43 &&
                            cuenta.status != 45 &&
                            role =='magistrado'"
                      v-model="voto_concurrente"
                      class="mt-5 ml-4"
                      label="Voto Concurrente"
                    ></v-checkbox>
                  </v-toolbar>
                  <v-row class="mb-3">
                    <v-col cols="6" v-if="voto_particular || cuenta.colegiada.voto_particular">
                      <v-card>
                        <v-card-title class="text-h6">
                          <v-icon left>
                            mdi-vote
                          </v-icon>
                          VOTO PARTICULAR
                        </v-card-title>
                        <v-card-subtitle
                          v-if="cuenta.colegiada.voto_particular"
                          class="text-h8 mb-3"
                        >
                          <v-list-item-title class="mt-3 mb-3">
                            {{ cuenta.colegiada.voto_particular.magistrado_nombre }}
                          </v-list-item-title>
                          {{ cuenta.colegiada.voto_particular.observaciones }}
                        </v-card-subtitle>
                        <v-card-subtitle v-if="!cuenta.colegiada.voto_particular">
                          <v-autocomplete
                            dense
                            class="mt-n1"
                            outlined
                            label="Seleccione un magistrado"
                            :item-text="item => item.magistrado"
                            item-value="user_id"
                            persistent-hint
                            :items = "getAllPonencias"
                            v-model="mag_voto_particular"
                          />
                          <v-textarea
                            class="mt-n4 mb-n3"
                            v-model="obs_voto_particular"
                            outlined
                            placeholder="Observaciones del Voto Particular"
                            rows="1"
                          ></v-textarea>
                        </v-card-subtitle>
                        <v-card-actions class="mt-n9">
                          <v-spacer></v-spacer>
                          <v-btn
                            v-if="!cuenta.colegiada.voto_particular"
                            @click="guardarVoto('P')"
                            color="orange"
                            text
                          >
                            Guardar
                          </v-btn>
                          <v-btn
                            v-if="cuenta.colegiada.voto_particular && cuenta.status<=44"
                            @click="clickEliminarVoto(cuenta.colegiada.voto_particular)"
                            color="red"
                            text
                          >
                            Eliminar
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                    <v-col cols="6" v-if="voto_concurrente || cuenta.colegiada.voto_concurrente">
                      <v-card>
                        <v-card-title class="text-h6">
                          <v-icon left>
                            mdi-vote
                          </v-icon>
                          VOTO CONCURRENTE
                        </v-card-title>
                        <v-card-subtitle
                          v-if="cuenta.colegiada.voto_concurrente"
                          class="text-h8  mb-3"
                        >
                          <v-list-item-title class="mt-3 mb-3">
                            {{ cuenta.colegiada.voto_concurrente.magistrado_nombre }}
                          </v-list-item-title>
                          {{ cuenta.colegiada.voto_concurrente.observaciones }}
                        </v-card-subtitle>
                        <v-card-subtitle v-if="!cuenta.colegiada.voto_concurrente">
                          <v-autocomplete
                            dense
                            class="mt-n1"
                            outlined
                            label="Seleccione un magistrado"
                            :item-text="item => item.magistrado"
                            item-value="user_id"
                            persistent-hint
                            :items = "getAllPonencias"
                            v-model="mag_voto_concurrente"
                          />
                          <v-textarea
                            class="mt-n4 mb-n3"
                            v-model="obs_voto_concurrente"
                            outlined
                            placeholder="Observaciones del Voto Concurrente"
                            rows="1"
                          ></v-textarea>
                        </v-card-subtitle>
                        <v-card-actions class="mt-n9">
                          <v-spacer></v-spacer>
                          <v-btn
                            v-if="!cuenta.colegiada.voto_concurrente"
                            @click="guardarVoto('C')"
                            color="orange"
                            text
                          >
                            Guardar
                          </v-btn>
                          <v-btn
                            v-if="cuenta.colegiada.voto_concurrente && cuenta.status<=44"
                            @click="clickEliminarVoto(cuenta.colegiada.voto_concurrente)"
                            color="red"
                            text
                          >
                            Eliminar
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                </div>
              </div>

            </v-col>
            <!-- fin detalles de la apelacion -->

          </v-row>
        </v-card-text>
        <!-- <v-card-actions v-if="role == 'secacu' || (role == 'magistrado' && apelacion.status < 40)">
          <v-spacer></v-spacer>
          <v-btn
            dark
            class="mt-6"
            color="red"
            :disabled="loading"
            @click="$emit('closeModal')"
          >Cerrar
          </v-btn>
        </v-card-actions><br> -->

        <!-- ARCHIVAR TOCA -->
        <!-- <div v-if="cuenta && cuenta.status==44 && cuenta.ponencia_id == currentUser.ponencia.id && !archivar_toca">
          <v-alert
            outlined
            prominent
            type="error"
          >
            <div class="text-h6">
              El Toca No Puede darse de Baja
            </div>
            <div>
            <ul class="list">
              <li>Faltan Firmas.</li>
            </ul>
            </div>
          </v-alert>
          <br>
        </div>
        <v-form v-if="cuenta && cuenta.status==44 && cuenta.ponencia_id == currentUser.ponencia.id && archivar_toca" ref="form" v-model="valid" lazy-validation>
          <div v-if="(cuenta && cuenta.status >=44)">
            <v-toolbar dense dark color="indigo lighten-1">
              <v-toolbar-title class="text-uppercase">Para archivar el Toca ingrese las fechas</v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card class="mt-3">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" class="mb-n3">
                    <v-menu
                      v-model="menu_fecha_sentencia"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="fecha_sentencia"
                          label="Fecha Sentencia"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-on="on"
                          v-bind="attrs"
                          outlined
                          dense
                          persistent-hint
                          :rules="[rules.required]"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="fecha_sentencia"
                        @input="menu_fecha_sentencia= false"
                        locale="es-mx"
                        outlined
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6" class="mb-n3">
                    <v-menu
                      v-model="menu_fecha_baja"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="fecha_baja"
                          label="Fecha Baja"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-on="on"
                          v-bind="attrs"
                          outlined
                          dense
                          persistent-hint
                          :rules="[rules.required]"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="fecha_baja"
                        @input="menu_fecha_baja= false"
                        locale="es-mx"
                        outlined
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="white--text"
                    color="green"
                    :disabled="!valid"
                    @click="validate()"
                  >Archivar toca
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-card>
          </div>
        </v-form> -->
      </v-card>
    </v-card>
    <v-dialog 
      v-model="dialogSinMateria" 
      persistent 
      max-width="900px"
    >
      <SinMateria v-if="cuenta" :cuenta_id="cuenta.id" @close="closeSinMateria"/>
    </v-dialog>
    <v-dialog 
      v-model="dialogCancelaToca" 
      persistent 
      max-width="900px"
    >
      <CancelaToca v-if="cuenta" :cuenta_id="cuenta.id" @close="closeCancelaToca"/>
    </v-dialog>
  </span>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ApelacionElectronica from "@/components/ApelacionElectronica";
  import SinMateria from "@/components/SinMateria";
  import CancelaToca from "@/components/CancelaToca";
  export default {
    components: {
      ApelacionElectronica, SinMateria, CancelaToca
    },
    props: {
      apelacion: {
        type: Object,
        required: true
      },
      cuenta: {
        type: Object,
        required: false
      },
      role: {
        type: String,
        required: true
      }
    },
    data: () => ({
      motivos:'',
      observaciones_sin_materia:'',
      dialogSinMateria: false,
      dialogCancelaToca: false,
      active_tab: {},
      valid: false,
      loading: false,
      menu_fecha_sentencia: false,
      menu_fecha_baja: false,
      fecha_sentencia: '',
      fecha_baja: '',
      archivar_toca: false,
      rules: {
        required:v => !!v.trim() || 'Campo requerido',
        requiredSelect:v => !!v|| 'Campo requerido'
      },
      voto_concurrente: false,
      voto_particular: false,
      mag_voto_particular: '',
      mag_voto_concurrente: '',
      obs_voto_particular:'',
      obs_voto_concurrente:'',
    }),
    computed: {
      ...mapGetters([ "currentUser", "getAllPonencias" ])
    },
    mounted(){
      this.$store.dispatch("GET_PONENCIAS", { url: "ponencias" });
      this.active_tab = this.$route.params
      if (this.cuenta && this.cuenta.colegiada) {
        this.resultado = this.apelacion.documentos.find( doc =>
          doc.categoria_id === 3 && doc.url_evidencia != null
        );
        if (this.resultado) {
          this.archivar_toca = true
        }
      }
    },
    // watch: {
    //   apelacion: function (val) {
    //     console.log(val)
    //   }
    // },
    methods:{
      sinMateria(){
        this.dialogSinMateria = true
      },
      closeSinMateria (val) {
        this.dialogSinMateria = false
        this.observaciones_sin_materia = ''
      },
      cancelaToca(){
        this.dialogCancelaToca = true
      },
      closeCancelaToca (val) {
        this.dialogCancelaToca = false
        this.motivos = ''
      },
      guardarVoto(tipo){
        if (tipo=='P') {
          this.magistrado = this.mag_voto_particular
          this.observaciones = this.obs_voto_particular
        } else {
          this.magistrado = this.mag_voto_concurrente
          this.observaciones = this.obs_voto_concurrente
        }
        if (!this.magistrado || !this.observaciones) {
          this.$swal({
            title: "Error!!!",
            text: 'Favor de seleccionar magistrado y/o agregar observaciones',
            icon: "error",
            confirmButtonText: "Aceptar"
          });
          return false;
        }
        this.$store.dispatch('CREATE_OBSERVACION_COLEGIADA', {
          url: '/colegiada/' + this.cuenta.colegiada.id + '/voto',
          data: {
            colegiada_id: this.cuenta.colegiada.id,
            user_id: this.currentUser.id,
            magistrado_id: this.magistrado,
            observaciones: this.observaciones,
            tipo: tipo
          }
        }).then(response => {
          if (response.data.status == "ok") {
            if (tipo=='P') {
              this.cuenta.colegiada.voto_particular = response.data.data.voto
              this.mag_voto_particular = ''
              this.obs_voto_particular = ''
              this.voto_particular = false
            } else {
              this.cuenta.colegiada.voto_concurrente = response.data.data.voto
              this.mag_voto_concurrente = ''
              this.obs_voto_concurrente = ''
              this.voto_concurrente = false
            }
            this.magistrado = ''
            this.observaciones = ''
            this.$swal({
              title: "Éxito!!!",
              text: 'Voto agregado correctamente',
              icon: "success",
              confirmButtonText: "Aceptar"
            });
          }
        }).catch(error => {
          console.log(error);
          this.loading = false;
          this.$swal({
            title: "Error",
            text: "Error al guardar",
            icon: "error",
            confirmButtonText: "Aceptar"
          });
        });
      },
      clickEliminarVoto(item){
        this.$swal({
         title: '¿Desea eliminar ' + (item.tipo == 'P' ? 'voto particular?' : 'voto concurrente?'),
         text: '',
         icon: 'question',
         showCancelButton: true,
         confirmButtonText: "Aceptar"
       }).then((result) => {
         if (result.value) {
           this.eliminarVoto(item);
         }
       })
      },
      eliminarVoto(item){
        this.$store.dispatch("DELETE_SENTIDO",  { url: "/voto/" + item.id } ).then(res => {
          if (item.tipo == 'P') {
            this.cuenta.colegiada.voto_particular = null
          } else {
            this.cuenta.colegiada.voto_concurrente = null
          }
          this.$swal({
            title: "Exito!!!",
            text: "Voto eliminado correctamente",
            icon: "success",
            confirmButtonText: "Aceptar"
          });
        });
      },
    }
  };
</script>
